import getEditButtons from './getEditButtons';
import getShareByEmailButton from './getShareByEmailButton';
import {
    getDefaultPreviewPaneCommandBarItems,
    PreviewPaneCommandBarItem,
} from 'owa-sxs/lib/utils/PreviewPaneCommandBarButton';

export default function getCommandBarButtonsForFilesHub(
    sxsId: string
): PreviewPaneCommandBarItem[] {
    return [
        ...getEditButtons(sxsId),
        ...getDefaultPreviewPaneCommandBarItems(),
        getShareByEmailButton(sxsId),
    ];
}
